export function midpoint(
  a: { x: number; y: number },
  b: { x: number; y: number }
): { x: number; y: number } {
  return { x: Math.round((a.x + b.x) / 2), y: Math.round((a.y + b.y) / 2) };
}

/**
 * Nudges a requested position diagonally until it clears every occupied
 * point by a small threshold. Used when adding new steps to prevent exact
 * overlap with existing ones.
 */
export function resolveNonOverlappingPosition(
  requested: { x: number; y: number },
  occupied: { x: number; y: number }[]
): { x: number; y: number } {
  const THRESHOLD = 30;
  const DELTA = 32;
  const MAX_ITERATIONS = 20;

  let { x, y } = requested;
  for (let i = 0; i < MAX_ITERATIONS; i++) {
    const collides = occupied.some(
      (p) => Math.abs(p.x - x) < THRESHOLD && Math.abs(p.y - y) < THRESHOLD
    );
    if (!collides) break;
    x += DELTA;
    y += DELTA;
  }
  return { x, y };
}
